import { useEffect } from "react";
import { useAccount, useDisconnect, useSignMessage } from "wagmi";

import { useAppDispatch, useAppSelector } from "store/store";
import { getProof } from "store/zkp/solana-proof/actions";

import { isErrorResult } from "services";
import { LOCAL_STORAGE_KEYS } from "configs";
import { SUPPORTED_ARBITRUM_CHAIN_ID } from "configs/web3";
import { handleWagmiError } from "utils";

import { ProofPayload } from "store/zkp/solana-proof/types";
import { checkArbitrumProof } from "store/zkp/arbitrum-proof/actions";
import { resetArbitrumProofState } from "store/zkp/arbitrum-proof";

const useHandleArbitrumProof = () => {
  const token = useAppSelector(state => state.auth.token);

  const { signMessage } = useSignMessage();
  const { disconnect } = useDisconnect();
  const { chainId, address } = useAccount();

  const dispatch = useAppDispatch();

  useEffect(() => {
    handleCheckLiskProof();
  }, [chainId, address]);

  const handleCheckLiskProof = async () => {
    try {
      const arbitrumAccessToken = localStorage.getItem(LOCAL_STORAGE_KEYS.arbitrumToken);
      const arbitrumWallet = localStorage.getItem(LOCAL_STORAGE_KEYS.arbitrumWallet);
      if (chainId && address && chainId === SUPPORTED_ARBITRUM_CHAIN_ID) {
        if (!arbitrumAccessToken || !arbitrumWallet || address !== arbitrumWallet) {
          dispatch(getProof()).then(res => {
            if (!isErrorResult(res.payload)) {
              const { payload } = res.payload as ProofPayload;
              signMessage(
                { message: payload },
                {
                  onError: error => {
                    handleDisconnectArbitrum();
                    handleWagmiError(error.message);
                    console.error("error in SignMessage", error);
                  },
                  onSuccess: data => {
                    dispatch(
                      checkArbitrumProof({ chainId: chainId.toString(), address, signature: data, payload }),
                    ).then(response => {
                      if (isErrorResult(response.payload)) {
                        handleDisconnectArbitrum();
                      } else {
                        localStorage.setItem(LOCAL_STORAGE_KEYS.arbitrumWallet, address);
                      }
                    });
                  },
                },
              );
            } else {
              handleDisconnectArbitrum();
            }
          });
        }
      }
    } catch (e) {
      console.error("Error in handleCheckLiskProof", e);
    }
  };

  const handleDisconnectArbitrum = () => {
    if (chainId && token) {
      disconnect();
    }
    dispatch(resetArbitrumProofState());
  };
};

export default useHandleArbitrumProof;
